import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
// import { hasPermission } from "../../../utils/commonfunction";
import logo from "../../../assets/admin/img/wellness-logo.png";
import { useTranslation } from "react-i18next";
import { detailsPermissions } from "../services/staff.services";
import { useState, useEffect } from "react";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();
  const [permissionData, setPermissionsData] = useState([]);

  const staffDataNew = localStorage.getItem("super_admin")
  const parsedStaffNew = JSON.parse(staffDataNew);

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  useEffect(() => {
    const staffData = localStorage.getItem("super_admin");
    const parsedStaff = JSON.parse(staffData);

    if (parsedStaff?.role === "super_admin") {
      setPermissionsData(["center_management", "supplement-management", "patient_management", "doctor_management", "staff",
        "cms_page", "faq", "video", "inquires", "appointment_management", "email_template", "general_settings","coach-specialization","report-management",""
      ]);
      return;
    }
    let formData = new FormData();
    formData.append("staff_id", parsedStaff?._id);
    detailsPermissions(formData)
      .then((response) => {
        const permissions = response?.data || [];
        const allowedSlugs = permissions.map(p => p.module_slug);
        setPermissionsData(allowedSlugs);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);


  const hasPermission = (slug) => permissionData.includes(slug);


  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard/1">
          <img
            src={logo}
            className="header-brand-img icon-logo admin-logo"
            alt="logo"
            style={{ height: "5rem", width: "auto" }}
            // style={{ height: "1.6rem", width: "auto" }}
            id="logo_short"
          />
          <img
            src={logo}
            className="header-brand-img desktop-logo admin-logo rounded"
            style={{ height: "5rem", width: "auto" }}
            // style={{ height: "2.3rem", width: "auto" }}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/dashboard/1" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/dashboard/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("admin.side_bar.sidebar_link_dashboard")}
              </span>
            </Link>
          </li>

          {hasPermission("center_management") && (
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/center-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/center-management/center/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                {/* <i className="fa fa-utensils sidemenu-icon"></i> */}
                {/* <i className="fa fa-coffee sidemenu-icon"></i> */}
                <i className="fa fa-building sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {/* {t("admin.side_bar.sidebar_link_cafes")} */}
                  {t("Wellness Centres")}
                </span>
              </Link>
            </li>
          )}

          {/* {hasPermission("doctor_management") && (

            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/doctor-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/doctor-management/doctor/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-cog sidemenu-icon"></i>
                <span className="sidemenu-label">
                  Doctor Management
                </span>
              </Link>
            </li>

          )} */}

          {/* {hasPermission("customer_management") && ( */}
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/customer-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/customer-management/customer/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-users sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("Customers")}
                </span>
              </Link>
            </li>
          {/* )} */}
          {/* {hasPermission("coach_management") && ( */}
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/coach-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/coach-management/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
               <i className="fas fa-chalkboard-teacher sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("Coaches")}
                </span>
              </Link>
            </li>
          {/* )} */}

          {/* {hasPermission("appointment_management") && (
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/appointment")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/appointment/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-calendar sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("Appointments")}
                </span>
              </Link>
            </li>
          )} */}
          {/* {parsedStaffNew.role !== 'staff' ?
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/staff") || loc.pathname.includes("/permissions")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/staff/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-users sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("Staff")}
                </span>
              </Link>
            </li>
            : null} */}

          {(hasPermission("cms_page") || hasPermission("faq") || hasPermission("video")) && (
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/cms") ? "show active" : "")
              }
            >
              <a
                className="nav-link with-sub submenu"
                onClick={toggleDropdown}
                href={"/"}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-edit sidemenu-icon"></i>
                <span className="sidemenu-label">{t("admin.side_bar.sidebar_link_cms")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                {hasPermission("cms_page") && (
                  <li
                    className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? " active" : ""
                      }`}
                  >
                    <Link
                      className="nav-sub-link"
                      to={`/admin/cms/pages/list/${1}`}
                    >
                      {t("admin.side_bar.sidebar_link_pages")}
                    </Link>
                  </li>
                )}
                {/* {hasPermission("faq") && (
                  <li
                    className={`nav-sub-item ${loc.pathname.includes("/cms/faq") ? " active" : ""
                      }`}
                  >
                    <Link
                      className="nav-sub-link"
                      to={`/admin/cms/faq/list/${1}`}
                    >
                      {t("admin.side_bar.sidebar_link_faq")}
                    </Link>
                  </li>
                )} */}
                {/* {hasPermission("video") && (
                  <li
                    className={`nav-sub-item ${loc.pathname.includes("/cms/video") ? " active" : ""
                      }`}
                  >
                    <Link
                      className="nav-sub-link"
                      to={`/admin/cms/video/list/${1}`}
                    >
                      {t("Video")}
                    </Link>
                  </li>
                )} */}
              </ul>
            </li>
          )}
          {hasPermission("email_template") && (
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/email-template")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/email-template/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-envelope sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("Email Templates")}
                </span>
              </Link>
            </li>
          )}

          {hasPermission("general_settings") && (
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/general-settings")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/general-settings`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-cog sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("General Settings")}
                </span>
              </Link>
            </li>
          )}

          {/* {hasPermission("inquires") && (
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/inquiries")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/inquiries/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fas fa-question-circle sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("admin.side_bar.sidebar_link_inquiries")}
                </span>
              </Link>
            </li>
          )} */}
          {hasPermission("coach-specialization") && (
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/coach-specialization") ? "show active" : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/coach-specialization/list/1`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-stethoscope sidemenu-icon"></i>
              <span className="sidemenu-label">Coach Specialization</span>
            </Link>
          </li>
           )}
           {hasPermission("supplement-management") && (
              <li
                className={
                  `nav-item ` +
                  (loc.pathname.includes("/supplement-management") ? "show active" : "")
                }
              >
                <Link
                  className="nav-link"
                  to={`/admin/supplement-management/list/1`}
                >
                  <span className="shape1"></span>
                  <span className="shape2"></span>
                  <i className="fas fa-capsules sidemenu-icon"></i>
                  <span className="sidemenu-label">Supplement</span>
                </Link>
              </li>
            )}

           {hasPermission("report-management") && (
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/report-management") ? "show active" : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/report-management/customer/list/1`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-clipboard-list sidemenu-icon"></i>
              <span className="sidemenu-label">Reports</span>
            </Link>
          </li>
          )} 
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
